const SILENT_TRPC_CODES = new Set(["UNAUTHORIZED", "FORBIDDEN"]);

type TrpcLoggerOpts = {
  direction: string;
  result?: unknown;
};

export function shouldLogTrpcFailure(opts: TrpcLoggerOpts): boolean {
  if (opts.direction !== "down" || !(opts.result instanceof Error)) {
    return false;
  }

  const code = (opts.result as { data?: { code?: string } }).data?.code;
  if (code && SILENT_TRPC_CODES.has(code)) {
    return false;
  }

  return true;
}
